/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Negotiate_Mistake_1Inputs */

const en_salary_negotiate_mistake_1 = /** @type {(inputs: Salary_Negotiate_Mistake_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accepting the first offer without negotiating`)
};

const de_salary_negotiate_mistake_1 = /** @type {(inputs: Salary_Negotiate_Mistake_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das erste Angebot ohne Verhandlung akzeptieren`)
};

const fr_salary_negotiate_mistake_1 = /** @type {(inputs: Salary_Negotiate_Mistake_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accepter la première offre sans négocier`)
};

const es_salary_negotiate_mistake_1 = /** @type {(inputs: Salary_Negotiate_Mistake_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aceptar la primera oferta sin negociar`)
};

const it_salary_negotiate_mistake_1 = /** @type {(inputs: Salary_Negotiate_Mistake_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accettare la prima offerta senza negoziare`)
};

const nl_salary_negotiate_mistake_1 = /** @type {(inputs: Salary_Negotiate_Mistake_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het eerste aanbod accepteren zonder te onderhandelen`)
};

const pl_salary_negotiate_mistake_1 = /** @type {(inputs: Salary_Negotiate_Mistake_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akceptowanie pierwszej oferty bez negocjacji`)
};

const fi_salary_negotiate_mistake_1 = /** @type {(inputs: Salary_Negotiate_Mistake_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ensimmäisen tarjouksen hyväksyminen neuvottelematta`)
};

const da_salary_negotiate_mistake_1 = /** @type {(inputs: Salary_Negotiate_Mistake_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`At acceptere det første tilbud uden at forhandle`)
};

const sv_salary_negotiate_mistake_1 = /** @type {(inputs: Salary_Negotiate_Mistake_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Att acceptera första erbjudandet utan att förhandla`)
};

/**
* | output |
* | --- |
* | "Accepting the first offer without negotiating" |
*
* @param {Salary_Negotiate_Mistake_1Inputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_negotiate_mistake_1 = /** @type {((inputs?: Salary_Negotiate_Mistake_1Inputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Negotiate_Mistake_1Inputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_negotiate_mistake_1(inputs)
	if (locale === "fr") return fr_salary_negotiate_mistake_1(inputs)
	if (locale === "es") return es_salary_negotiate_mistake_1(inputs)
	if (locale === "it") return it_salary_negotiate_mistake_1(inputs)
	if (locale === "nl") return nl_salary_negotiate_mistake_1(inputs)
	if (locale === "pl") return pl_salary_negotiate_mistake_1(inputs)
	if (locale === "fi") return fi_salary_negotiate_mistake_1(inputs)
	if (locale === "da") return da_salary_negotiate_mistake_1(inputs)
	if (locale === "sv") return sv_salary_negotiate_mistake_1(inputs)
	return en_salary_negotiate_mistake_1(inputs)
});